import { library } from '@fortawesome/fontawesome-svg-core'
import { faLoader as fadLoader } from '@fortawesome/pro-duotone-svg-icons/faLoader'
import { faPlateUtensils } from '@fortawesome/pro-duotone-svg-icons/faPlateUtensils'
import { faAddressBook as falAddressBook } from '@fortawesome/pro-light-svg-icons/faAddressBook'
import { faArrowDownToLine as falArrowDownToLine } from '@fortawesome/pro-light-svg-icons/faArrowDownToLine'
import { faArrowRightFromBracket as falArrowRightFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowRightFromBracket'
import { faArrowsRepeat as falArrowsRepeat } from '@fortawesome/pro-light-svg-icons/faArrowsRepeat'
import { faArrowUpFromLine as falArrowUpFromLine } from '@fortawesome/pro-light-svg-icons/faArrowUpFromLine'
import { faArrowUpRightFromSquare as falArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare'
import { faArrowUpToLine as falArrowUpToLine } from '@fortawesome/pro-light-svg-icons/faArrowUpToLine'
import { faBell as falBell } from '@fortawesome/pro-light-svg-icons/faBell'
import { faBook as falBook } from '@fortawesome/pro-light-svg-icons/faBook'
import { faBookOpen as falBookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen'
import { faCalendar as falCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar'
import { faCalendarDay as falCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay'
import { faCalendarPlus as falCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus'
import { faCheck as falCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronLeft as falChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faChevronUp as falChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
import { faCircleUser as falCircleUser } from '@fortawesome/pro-light-svg-icons/faCircleUser'
import { faClipboardCheck as falClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck'
import { faClock as falClock } from '@fortawesome/pro-light-svg-icons/faClock'
import { faClose as falClose } from '@fortawesome/pro-light-svg-icons/faClose'
import { faCog as falCog } from '@fortawesome/pro-light-svg-icons/faCog'
import { faCommentAlt as falCommentAlt } from '@fortawesome/pro-light-svg-icons/faCommentAlt'
import { faDoorClosed as falDoorClosed } from '@fortawesome/pro-light-svg-icons/faDoorClosed'
import { faDownLong as falDownLong } from '@fortawesome/pro-light-svg-icons/faDownLong'
import { faDownload as falDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faEnvelope as falEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faExclamationTriangle as falExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faExternalLink as falExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
import { faEye as falEye } from '@fortawesome/pro-light-svg-icons/faEye'
import { faEyeSlash as falEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash'
import { faFax as falFax } from '@fortawesome/pro-light-svg-icons/faFax'
import { faFile as falFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFileArrowUp as falFileArrowUp } from '@fortawesome/pro-light-svg-icons/faFileArrowUp'
import { faFileCheck as falFileCheck } from '@fortawesome/pro-light-svg-icons/faFileCheck'
import { faFileInvoice as falFileInvoice } from '@fortawesome/pro-light-svg-icons/faFileInvoice'
import { faFileLines as falFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines'
import { faFileMedical as falFileMedical } from '@fortawesome/pro-light-svg-icons/faFileMedical'
import { faFilePdf as falFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFileUser as falFileUser } from '@fortawesome/pro-light-svg-icons/faFileUser'
import { faFilter as falFilter } from '@fortawesome/pro-light-svg-icons/faFilter'
import { faFolderMedical as falFolderMedical } from '@fortawesome/pro-light-svg-icons/faFolderMedical'
import { faGlobe as falGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faHome as falHome } from '@fortawesome/pro-light-svg-icons/faHome'
import { faHourglass as falHourglass } from '@fortawesome/pro-light-svg-icons/faHourglass'
import { faHourglassClock as falHourglassClock } from '@fortawesome/pro-light-svg-icons/faHourglassClock'
import { faHouseMedical as falHouseMedical } from '@fortawesome/pro-light-svg-icons/faHouseMedical'
import { faImage as falImage } from '@fortawesome/pro-light-svg-icons/faImage'
import { faInfo as falInfo } from '@fortawesome/pro-light-svg-icons/faInfo'
import { faInfoCircle as falInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import { faLoader as falLoader } from '@fortawesome/pro-light-svg-icons/faLoader'
import { faLocationArrow as falLocationArrow } from '@fortawesome/pro-light-svg-icons/faLocationArrow'
import { faLocationDot as falLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot'
import { faLocationPin as falLocationPin } from '@fortawesome/pro-light-svg-icons/faLocationPin'
import { faLock as falLock } from '@fortawesome/pro-light-svg-icons/faLock'
import { faMagnifyingGlass as falMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass'
import { faMessage as falMessage } from '@fortawesome/pro-light-svg-icons/faMessage'
import { faMessageCheck as falMessageCheck } from '@fortawesome/pro-light-svg-icons/faMessageCheck'
import { faMessageDots as falMessageDots } from '@fortawesome/pro-light-svg-icons/faMessageDots'
import { faNewspaper as falNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper'
import { faNoteMedical as falNoteMedical } from '@fortawesome/pro-light-svg-icons/faNoteMedical'
import { faPause as falPause } from '@fortawesome/pro-light-svg-icons/faPause'
import { faPersonWalking as falPersonWalking } from '@fortawesome/pro-light-svg-icons/faPersonWalking'
import { faPhone as falPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faPodcast as falPodcast } from '@fortawesome/pro-light-svg-icons/faPodcast'
import { faPrescriptionBottle as falPrescriptionBottle } from '@fortawesome/pro-light-svg-icons/faPrescriptionBottle'
import { faQuestionCircle as falQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import { faRectangleHistory as falRectangleHistory } from '@fortawesome/pro-light-svg-icons/faRectangleHistory'
import { faReply as falReply } from '@fortawesome/pro-light-svg-icons/faReply'
import { faSalad as falSalad } from '@fortawesome/pro-light-svg-icons/faSalad'
import { faShieldCheck as falShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck'
import { faSignature as falSignature } from '@fortawesome/pro-light-svg-icons/faSignature'
import { faSwapArrows as falSwapArrows } from '@fortawesome/pro-light-svg-icons/faSwapArrows'
import { faTimesCircle as falTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faTrashCan as falTrashCan } from '@fortawesome/pro-light-svg-icons/faTrashCan'
import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faUserDoctor as falUserDoctor } from '@fortawesome/pro-light-svg-icons/faUserDoctor'
import { faUserPen as falUserPen } from '@fortawesome/pro-light-svg-icons/faUserPen'
import { faUtensils as falUtensils } from '@fortawesome/pro-light-svg-icons/faUtensils'
import { faVideo as falVideo } from '@fortawesome/pro-light-svg-icons/faVideo'
import { faArrowLeft as farArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faBadgePercent as farBadgePercent } from '@fortawesome/pro-regular-svg-icons/faBadgePercent'
import { faBarsFilter as farBarsFilter } from '@fortawesome/pro-regular-svg-icons/faBarsFilter'
import { faCalendar as farCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar'
import { faCamera as farCamera } from '@fortawesome/pro-regular-svg-icons/faCamera'
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle'
import { faChevronLeft as farChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import { faChevronRight as farChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faCircleInfo as farCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo'
import { faCircleThreeQuartersStroke as farCircleThreeQuartersStroke } from '@fortawesome/pro-regular-svg-icons/faCircleThreeQuartersStroke'
import { faClapperboardPlay as farClapperboardPlay } from '@fortawesome/pro-regular-svg-icons/faClapperboardPlay'
import { faClipboard as farClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard'
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { faClose as farClose } from '@fortawesome/pro-regular-svg-icons/faClose'
import { faCoins as farCoins } from '@fortawesome/pro-regular-svg-icons/faCoins'
import { faCopy as farCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faFireFlameCurved as farFireFlameCurved } from '@fortawesome/pro-regular-svg-icons/faFireFlameCurved'
import { faGift as farGift } from '@fortawesome/pro-regular-svg-icons/faGift'
import { faHourglass as farHourglass } from '@fortawesome/pro-regular-svg-icons/faHourglass'
import { faLocationDot as farLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot'
import { faMedal as farMedal } from '@fortawesome/pro-regular-svg-icons/faMedal'
import { faPen as farPen } from '@fortawesome/pro-regular-svg-icons/faPen'
import { faPersonRunning as farPersonRunning } from '@fortawesome/pro-regular-svg-icons/faPersonRunning'
import { faRoadBarrier as farRoadBarrier } from '@fortawesome/pro-regular-svg-icons/faRoadBarrier'
import { faShareFromSquare as farShareFromSquare } from '@fortawesome/pro-regular-svg-icons/faShareFromSquare'
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation'
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser'
import { faXmark as farXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'
import { faAddressBook as fasAddressBook } from '@fortawesome/pro-solid-svg-icons/faAddressBook'
import { faCalendar as fasCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar'
import { faCircleCheck as fasCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck'
import { faCog as fasCog } from '@fortawesome/pro-solid-svg-icons/faCog'
import { faFile as fasFile } from '@fortawesome/pro-solid-svg-icons/faFile'
import { faFilter as fasFilter } from '@fortawesome/pro-solid-svg-icons/faFilter'
import { faFolderMedical as fasFolderMedical } from '@fortawesome/pro-solid-svg-icons/faFolderMedical'
import { faHouse as fasHouse } from '@fortawesome/pro-solid-svg-icons/faHouse'
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock'
import { faNoteMedical as fasNoteMedical } from '@fortawesome/pro-solid-svg-icons/faNoteMedical'
import { faPause as fasPause } from '@fortawesome/pro-solid-svg-icons/faPause'
import { faPlay as fasPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faPrescriptionBottle as fasPrescriptionBottle } from '@fortawesome/pro-solid-svg-icons/faPrescriptionBottle'
import { faRectangleHistory as fasRectangleHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleHistory'
import { faShieldCheck as fasShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import { faSparkle as fasSparkle } from '@fortawesome/pro-solid-svg-icons/faSparkle'
import { faSwapArrows as fasSwapArrows } from '@fortawesome/pro-solid-svg-icons/faSwapArrows'
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { useEffect } from 'react'

const FontAwesomeProvider = () => {
  useEffect(() => {
    // Add all the used icons in the project to the library
    library.add(
      // Branding Icons

      // Light Icons
      falAddressBook,
      falArrowDownToLine,
      falArrowRightFromBracket,
      falArrowsRepeat,
      falArrowsRepeat,
      falArrowUpRightFromSquare,
      falArrowUpToLine,
      falArrowUpFromLine,
      falBell,
      falBook,
      falBookOpen,
      falCalendar,
      falCalendarDay,
      falCalendarPlus,
      falCheck,
      falCheckCircle,
      falChevronDown,
      falChevronLeft,
      falChevronRight,
      falChevronUp,
      falCircleUser,
      falClipboardCheck,
      falClock,
      falClose,
      falCog,
      falCommentAlt,
      falDoorClosed,
      falDownload,
      falDownLong,
      falEnvelope,
      falExclamationTriangle,
      falExternalLink,
      falEye,
      falEyeSlash,
      falFax,
      falFile,
      falFileArrowUp,
      falFilePdf,
      falFileCheck,
      falFileInvoice,
      falFileLines,
      falFileMedical,
      falFileUser,
      falFilter,
      falFolderMedical,
      falGlobe,
      falHome,
      falHourglass,
      falHourglassClock,
      falHouseMedical,
      falImage,
      falInfo,
      falInfoCircle,
      falLoader,
      falLocationArrow,
      falLocationDot,
      falLocationPin,
      falLock,
      falMagnifyingGlass,
      falMessage,
      falMessageCheck,
      falMessageDots,
      falNewspaper,
      falNoteMedical,
      falPause,
      falPersonWalking,
      falPhone,
      falPlus,
      falPodcast,
      falPrescriptionBottle,
      falQuestionCircle,
      falRectangleHistory,
      falReply,
      falSalad,
      falShieldCheck,
      falSignature,
      falSwapArrows,
      falTimesCircle,
      falTrashCan,
      falUser,
      falUserDoctor,
      falUserPen,
      falUtensils,
      falVideo,

      // Regular Icons
      farArrowLeft,
      farBadgePercent,
      farBarsFilter,
      farCalendar,
      farCamera,
      farCheckCircle,
      farChevronLeft,
      farChevronRight,
      farCircleInfo,
      farClapperboardPlay,
      farClock,
      farClose,
      farCoins,
      farCopy,
      farFireFlameCurved,
      farGift,
      farHourglass,
      farLocationDot,
      farMedal,
      farPen,
      farPersonRunning,
      farRoadBarrier,
      farShareFromSquare,
      farTriangleExclamation,
      farUser,
      farXmark,
      farClipboard,
      farCircleThreeQuartersStroke,
      farPen,

      // Solid Icons
      fasAddressBook,
      fasCalendar,
      fasCircleCheck,
      fasCog,
      fasFile,
      fasFilter,
      fasFolderMedical,
      fasHouse,
      fasLock,
      fasNoteMedical,
      fasPause,
      fasPlay,
      fasPrescriptionBottle,
      fasRectangleHistory,
      fasShieldCheck,
      fasSparkle,
      fasSwapArrows,
      fasUser,

      // Duotone Icons
      fadLoader,
      faPlateUtensils,
    )
  }, [])

  return null
}

export { FontAwesomeProvider }
